
import React from "react";
import { EducationAutocomplete } from "@/components/shared/EducationAutocomplete";

interface ImprovedEducationAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const ImprovedEducationAutocomplete: React.FC<ImprovedEducationAutocompleteProps> = ({
  value,
  onChange,
  error
}) => {
  return (
    <EducationAutocomplete
      value={value}
      onChange={onChange}
      error={error}
      label="Formação acadêmica"
      placeholder="Digite ou selecione sua formação"
      className=""
    />
  );
};
